module.exports = __webpack_public_path__ + "assets/img/bgPoster.8555652c.jpg";